import { Model } from '@/clients/http'

import { BusinessHttpParams, BusinessResponses } from '@/types'

export class BusinessModel extends Model {
  public static readonly correlations = {
    GET_BUSINESS_PROFILE: 'BUSINESS_PROFILE',
    UPDATE_CUSTOM_DOMAIN: 'BUSINESS_CUSTOM_DOMAIN',
  }

  public static readonly endpoints = {
    getBusinessProfile: () => '/api/backoffice/profile/business',
    updateCustomDomain: () => '/api/backoffice/profile/business/custom-domain',
  }

  public static readonly getBusinessProfile = async (
    props?: BusinessHttpParams.GetBusinessProfile
  ) => {
    return this.createHttpRequest<BusinessResponses.BusinessProfile>({
      correlationKey: this.correlations.GET_BUSINESS_PROFILE,
      payload: {
        method: 'get',
        url: this.endpoints.getBusinessProfile(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly updateBusinessProfile = async (
    props: BusinessHttpParams.UpdateBusinessProfile
  ) => {
    return this.createHttpRequest<BusinessResponses.BusinessProfile>({
      correlationKey: this.correlations.GET_BUSINESS_PROFILE,
      payload: {
        method: 'put',
        url: this.endpoints.getBusinessProfile(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly updateCustomDomain = async (
    props: BusinessHttpParams.UpdateCustomDomain
  ) => {
    return this.createHttpRequest<BusinessResponses.BusinessProfile>({
      correlationKey: this.correlations.UPDATE_CUSTOM_DOMAIN,
      payload: {
        method: 'put',
        url: this.endpoints.updateCustomDomain(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
